import { types, actions } from './requests'
export const GETROLELIST_TYPES = {
    ...types('GETROLELIST'),
}
export const GETROLELIST_ACTIONS = {
    ...actions('GETROLELIST'),
}
